import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData, Spacing, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CongressContainerContentTextConverter extends CmsConverterService<CongressContainerContentTextData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
      spacing: {
        bottom: formData.st_spacing_bottom?.value?.identifier ?? '',
        top: formData.st_spacing_top?.value?.identifier ?? ''
      },
    }
  }
}

export const CONGRESS_CONTAINER_CONTENT_TEXT_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, CongressContainerContentTextData>>('CongressContainerContentTextConverter')

export interface CongressContainerContentTextData extends ConvertedComponentData {
  headline: TextInput;
  text: TextInput;
  spacing: Spacing;
}
